<div class="main-container">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>Edit Role</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">Error occurred</div>

        <app-mat-text-input
          [formControl]="getFormControl('name')"
          label="Role Name"
          name="name"
          [submitted]="submitted || editModel.isSystem"
        ></app-mat-text-input>
        <app-mat-text-input
          [formControl]="getFormControl('description')"
          label="Description"
          name="description"
          [submitted]="submitted || editModel.isSystem"
        ></app-mat-text-input>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-title>Permissions</mat-card-title>
      <mat-card-content>
        <mat-accordion multi>
          <mat-expansion-panel *ngFor="let tab of filteredTabs; let i = index">
            <mat-expansion-panel-header>
              <mat-panel-title style="font-size: 14px; font-weight: 500; color: #1a2451">
                {{ tab.title }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="permissions-wrapper" *ngFor="let module of modules | filterModules: tab.group">
              <div class="permission-title-wrapper">
                <strong>{{ module.name }}</strong>
                <span class="form-text text-muted">{{ module.description }}</span>
              </div>
              <div class="permission-wrapper" fxLayout="column">
                <mat-radio-group
                  [formControl]="getFormControl(module.permissionPrefix)"
                  [disabled]="editModel.isSystem"
                >
                  <mat-radio-button
                    class="example-radio-button"
                    *ngFor="let permission of module.permissions"
                    [value]="permission.permissionKey"
                    [disabled]="!hasPermissionToEnable(permission)"
                  >
                    {{ permission.name }}
                  </mat-radio-button>
                </mat-radio-group>
                <ng-container *ngFor="let permission of module.additionalPermissions">
                  <app-mat-multiselect
                    *ngIf="permission.inputType === 'PbxExtensionsInputComponent'"
                    [hintLabel]="permission.description"
                    placeholder="Type to search agents"
                    [label]="permission.name"
                    [name]="permission.inputName"
                    [submitted]="submitted || editModel.isSystem"
                    [formControl]="getFormControl(permission.inputName)"
                    [autoCompleteValues]="reportsService.extensionsLookupList"
                    [suffixIcon]="'person'"
                    [excludeValues]="
                      permission.inputName === 'Reports_Extensions'
                        ? excludeExcludedExtensions
                        : permission.inputName === 'Reports_Exclude_Extensions'
                          ? excludeExtensions
                          : permission.inputName === 'Recordings_Extensions'
                            ? excludeRecordingExcludedExtensions
                            : permission.inputName === 'Recordings_Exclude_Extensions'
                              ? excludeRecordingExtensions
                              : []
                    "
                    [disabled]="!hasSpecialPermissionToEnable(permission)"
                    suffixTooltip="Open List"
                    (valueChanged)="onPbxExtensionsInputValueChange($event, permission.inputName)"
                    (onSuffixClicked)="
                      onPbxAccounts(
                        $event,
                        getFormControl(permission.inputName),
                        reportsService.extensionsLookup,
                        'Select ' + permission.name,
                        permission.name,
                        permission.inputName === 'Reports_Extensions'
                          ? excludeExcludedExtensions
                          : permission.inputName === 'Reports_Exclude_Extensions'
                            ? excludeExtensions
                            : permission.inputName === 'Recordings_Extensions'
                              ? excludeRecordingExcludedExtensions
                              : permission.inputName === 'Recordings_Exclude_Extensions'
                                ? excludeRecordingExtensions
                                : []
                      )
                    "
                  >
                  </app-mat-multiselect>
                  <app-mat-multiselect
                    *ngIf="permission.inputType === 'PbxGroupsInputComponent'"
                    [hintLabel]="permission.description"
                    placeholder="Type to search groups"
                    [label]="permission.name"
                    [name]="permission.inputName"
                    [submitted]="submitted || editModel.isSystem"
                    [formControl]="getFormControl(permission.inputName)"
                    [autoCompleteValues]="reportsService.groupsLookupList"
                    [suffixIcon]="'group'"
                    [disabled]="!hasSpecialPermissionToEnable(permission)"
                    suffixTooltip="Open List"
                    (onSuffixClicked)="
                      onPbxAccounts(
                        $event,
                        getFormControl(permission.inputName),
                        reportsService.groupsLookup,
                        'Select ' + permission.name,
                        permission.name,
                        []
                      )
                    "
                  >
                  </app-mat-multiselect>
                  <app-mat-multiselect
                    *ngIf="permission.inputType === 'PbxDepartmentsInputComponent'"
                    [hintLabel]="permission.description"
                    placeholder="Type to search departments"
                    [label]="permission.name"
                    [name]="permission.inputName"
                    [submitted]="submitted || editModel.isSystem"
                    [formControl]="getFormControl(permission.inputName)"
                    [autoCompleteValues]="departmentsLookupList"
                    [suffixIcon]="'domain'"
                    [disabled]="!hasSpecialPermissionToEnable(permission)"
                    suffixTooltip="Open List"
                    (onSuffixClicked)="
                      onPbxAccounts(
                        $event,
                        getFormControl(permission.inputName),
                        departmentsLookup,
                        'Select ' + permission.name,
                        permission.name,
                        []
                      )
                    "
                  >
                  </app-mat-multiselect>
                  <app-mat-multiselect
                    *ngIf="permission.inputType === 'PbxOtherAccountsInputComponent'"
                    [hintLabel]="permission.description"
                    placeholder="Type to search other accounts"
                    [label]="permission.name"
                    [name]="permission.inputName"
                    [submitted]="submitted || editModel.isSystem"
                    [formControl]="getFormControl(permission.inputName)"
                    [autoCompleteValues]="reportsService.otherAccountsLookupList"
                    [suffixIcon]="'person'"
                    suffixTooltip="Open List"
                    [disabled]="!hasSpecialPermissionToEnable(permission)"
                    (onSuffixClicked)="
                      onPbxAccounts(
                        $event,
                        getFormControl(permission.inputName),
                        reportsService.otherAccountsLookup,
                        'Select ' + permission.name,
                        permission.name,
                        []
                      )
                    "
                  >
                  </app-mat-multiselect>
                  <app-mat-text-input
                    *ngIf="permission.inputType === 'SimpleInputComponent'"
                    [title]="permission.description"
                    [formControl]="getFormControl(permission.inputName)"
                    [label]="permission.name"
                    [name]="permission.inputName"
                    [disabled]="!hasSpecialPermissionToEnable(permission)"
                    [submitted]="submitted || editModel.isSystem"
                  ></app-mat-text-input>
                  <app-mat-checkbox-input
                    *ngIf="permission.inputType === 'CheckboxInputComponent'"
                    [title]="permission.description"
                    [formControl]="getFormControl(permission.inputName)"
                    [label]="permission.name"
                    [name]="permission.inputName"
                    [disabled]="!hasSpecialPermissionToEnable(permission)"
                    [submitted]="submitted || editModel.isSystem"
                  ></app-mat-checkbox-input>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-card-content>
    </mat-card>
  </form>
</div>
<div class="has-edit-action-bar">&nbsp;</div>
<div class="edit-action-bar" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
  <button
    mat-raised-button
    type="button"
    color="primary"
    matTooltip="Save changes"
    (click)="onSubmit()"
    [disabled]="submitted || form.invalid"
    [promiseBtn]="buttonSubmitPromise"
    *ngIf="hasEditAccess && (isClone || !editModel.isSystem)"
  >
    Save
  </button>
  <button
    mat-raised-button
    color="warn"
    class="only-icon"
    type="button"
    matTooltip="Remove role"
    *ngIf="hasEditAccess && !editModel.isSystem && editModel.id && editModel.id !== 'new'"
    (click)="onDeleteClick()"
  >
    <mat-icon>delete</mat-icon>
  </button>
</div>
